import { DatePipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IEvaluatorList } from "app/models/core/admin/masterTables";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";


@Component({
  selector: 'app-evaluatorList',
  templateUrl: './evaluatorList.component.html'

})

export class EvaluatorListComponent implements OnInit {

  list: IEvaluatorList[] = [];
  evaluator: IEvaluatorList;
  displayedColumns: string[] = ['code', 'name', 'lastupdated', 'updatedBy', 'action'];

  dataSource = new MatTableDataSource<IEvaluatorList>(this.list);

  listFilter = '';
  editMode = 'list';

  evaluatorFormGroup = new UntypedFormGroup({
    Code: new UntypedFormControl('', [Validators.required, Validators.maxLength(10)]),
    Name: new UntypedFormControl('', [Validators.required, Validators.maxLength(40)]),
    Address: new UntypedFormControl('', [Validators.maxLength(30)]),
    City: new UntypedFormControl('', [Validators.maxLength(14)]),
    State: new UntypedFormControl('', [Validators.maxLength(2)]),
    Zip: new UntypedFormControl('', [Validators.maxLength(9)]),
    Program: new UntypedFormControl('', [Validators.maxLength(40)]),
    Telephone: new UntypedFormControl('', [Validators.maxLength(10)]),
    Fax: new UntypedFormControl('', [Validators.maxLength(10)]),
    Datecreated: new UntypedFormControl(''),
    CreatedBy: new UntypedFormControl(''),
    Lastupdated: new UntypedFormControl(''),
    UpdatedBy: new UntypedFormControl(''),
  });

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private datePipe: DatePipe) { };

  ngOnInit() {
    this.editMode = 'list';
    this.loadEvaluatorList();
  }

  loadEvaluatorList() {
    this.adminService.getEvaluatorCodes().subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      error => console.log('error: ', error),
      () => {
        this.editMode = 'list';
      }
    );
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  editEvaluator(evaluator: IEvaluatorList) {
    this.evaluator = evaluator;
    this.evaluatorFormGroup.patchValue({
      Code: evaluator.code,
      Name: evaluator.name,
      Address: evaluator.address,
      City: evaluator.city,
      State: evaluator.state,
      Zip: evaluator.zip,
      Program: evaluator.program,
      Telephone: evaluator.telephone,
      Fax: evaluator.fax,
      Datecreated: evaluator.datecreated,
      CreatedBy: evaluator.createdBy,
      Lastupdated: evaluator.lastupdated,
      UpdatedBy: evaluator.updatedBy
    });
    this.evaluatorFormGroup.markAsPristine();
    this.editMode = 'edit';
  }

  print() {
    //TODO
  }

  addEvaluator() {
    this.clearForm();
    this.editMode = 'add';
  }

  clearForm() {
    this.evaluatorFormGroup.patchValue({
      Code: '',
      Name: '',
      Address: '',
      City: '',
      State: '',
      Zip: '',
      Program: '',
      Telephone: '',
      Fax: '',
      Datecreated: this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
      CreatedBy: '',
      Lastupdated: this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
      UpdatedBy: ''
    }
    );
  }

  saveEvaluator() {
    if (this.evaluatorFormGroup.valid) {
      let form = this.evaluatorFormGroup.getRawValue();

      // Checking for duplicate codes
      let duplicate = false
      if (this.editMode == 'add') {
        let newCode = form.Code;
        this.list.forEach(function (val) {
          if (val.code == newCode) {
            alert('Duplicate Evaluator Code. Please edit existing record.');
            duplicate = true;
          }
        });
      }

      if (!duplicate) {
        let evaluator: IEvaluatorList = {
          code: form.Code,
          name: form.Name,
          address: form.Address,
          city: form.City,
          state: form.State,
          zip: form.Zip,
          program: form.Program,
          telephone: form.Telephone,
          fax: form.Fax,
          datecreated: form.Datecreated,
          createdBy: form.CreatedBy,
          lastupdated: form.Lastupdated,
          updatedBy: form.UpdatedBy
        };
        this.adminService.saveEvaluator(evaluator, 'Save').subscribe(
          () => {
            this.loadEvaluatorList();
          },
          error => console.log('error: ', error),
          () => {
          }
        );
      }
    }
  }

  deleteEvaluator() {
    if (this.evaluatorFormGroup.dirty) {
      if (!confirm('DELETE Evaluator? Continue?')) {
        return;
      }
    }
    this.adminService.saveEvaluator(this.evaluator, 'Delete').subscribe(
      () => {
        this.loadEvaluatorList();
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  cancel() {
    if (this.evaluatorFormGroup.dirty) {
      if (!confirm('Unsaved changes. Continue?')) {
        return;
      }
    }
    this.clearForm();
    this.editMode = 'list';
  }

}